import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import campanhaService from 'services/campanha-service/campanha-service';
import { getCampaignFileNameBase } from 'utils/campanha-utils';

const generatePdf = async (
  logs: any,
  campaignName: string,
  campaignId: number,
  csvError: Blob | undefined,
  isDownload: boolean,
): Promise<void> => {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const sortArray = (array) => {
    array.sort((a, b) => {
      const splitA = a.split('|');
      const splitB = b.split('|');

      return (
        parseInt(splitA[2].replace(/\D/g, ''), 10) -
        parseInt(splitB[2].replace(/\D/g, ''), 10)
      );
    });
  };

  const documentTitle = [
    {
      stack: [
        {
          text: 'Resultado do envio da campanha:',
          fontSize: 14,
          bold: true,
          margin: [20, 30, 20, 0],
        },
        { text: campaignName, fontSize: 14, margin: [20, 0, 20, 30] },
      ],
    },
  ];

  const renderLogTable = (lines: string[]) => {
    if (lines.length <= 0) {
      return [];
    }

    sortArray(lines);

    return lines.map((log) => {
      const [line, name, email, phone, importLogs] = log.split('|');
      const msgList = importLogs.split('\n').filter((msg) => msg);

      return [
        {
          text: (line || '').replace('Linha ', ''),
          fontSize: 10,
          margin: [0, 2, 0, 2],
        },
        {
          text: name,
          fontSize: 10,
          margin: [0, 2, 0, 2],
        },
        {
          text: email,
          fontSize: 10,
          margin: [0, 2, 0, 2],
        },
        {
          text: phone,
          fontSize: 10,
          margin: [0, 2, 0, 2],
        },
        {
          text: msgList,
          fontSize: 10,
          margin: [0, 2, 0, 2],
        },
      ];
    });
  };

  const sucessDetails = [
    {
      text: `${logs.numLinhasSucesso} ${
        logs.numLinhasSucesso === 1 ? 'linha enviada' : 'linhas enviadas'
      } com sucesso`,
      fontSize: 14,
      margin: [0, 15, 50, 0],
      bold: true,
    },
  ];

  const errorDetails = [
    {
      text: `${logs.numLinhasErro} ${
        logs.numLinhasErro === 1
          ? 'linha não foi importada devido a erros.'
          : 'linhas não foram importadas devido a erros.'
      }`,
      fontSize: 14,
      margin: [0, 25, 0, 15],
      bold: true,
    },
  ];

  const erorTable = [
    {
      table: {
        haderRows: 1,
        widths: [30, 140, 110, 60, '*'],
        body: [
          [
            { text: 'Linha', style: 'tableHeader', fontSize: 10 },
            { text: 'Nome', style: 'tableHeader', fontSize: 10 },
            { text: 'E-mail', style: 'tableHeader', fontSize: 10 },
            { text: 'Telefone', style: 'tableHeader', fontSize: 10 },
            { text: 'Erros', style: 'tableHeader', fontSize: 10 },
          ],
          ...renderLogTable(logs.linhasErros),
        ],
      },
    },
  ];

  const docDefinitions = {
    pageSize: 'A4',
    pageMargins: [20, 80, 20, 50],
    header: [documentTitle],
    content: [
      sucessDetails,
      errorDetails,
      logs.numLinhasErro > 0 ? erorTable : {},
    ],
  };
  const campaignFileName = getCampaignFileNameBase(campaignName);
  const pdfFileName = `${campaignFileName}-Resultado_do_envio_da_campanha.pdf`;
  const csvFileName = `${campaignFileName}-planilha_para_correcao.csv`;

  if (isDownload) {
    pdfMake.createPdf(docDefinitions).download(pdfFileName);
  } else {
    pdfMake.createPdf(docDefinitions).getBlob(async (blob) => {
      const pdfFile = new File([blob], pdfFileName, {
        type: 'application/pdf',
      });

      let csvFile;
      if (csvError) {
        csvFile = new File([csvError], csvFileName, {
          type: 'application/csv',
        });
      }

      await campanhaService.saveRelatorioCampanhas(
        campaignId,
        logs.numeroLinhas,
        logs.numLinhasErro,
        logs.numLinhasSucesso,
        csvFile,
        pdfFile,
      );
    });
    pdfMake.createPdf(docDefinitions).download(pdfFileName);
  }
};

export default generatePdf;
